import client from '../client';
// import client from '../client';

const mutate = ({ key, method, data }) => {
  return client()
    [method?.toLowerCase()](`/${key}`, data)
    .then((res) => res.data);
};

export default mutate;
